import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import React,{ useState , useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import headerImg from '../images/Stepper2.png'; 
import stepper from '../hybridImages/Stepper2.png';
import pStepper from '../hybridImages/PStepper2.png';  
import subAPImg from '../images/SubAPStepper2.png';
import personDtlsData from '../data/persondetailsdata.json'
import { FormTitle,CusFormSectionLabel } from '../validation/Form-Components';
import SubHeader from '../components/SubHeader';
import ToggleShowDetails from '../components/ToggleShowDetails';
import AuthPerson from './AuthPerson';
import config from '../appconfig/config.json';
import service from '../services/PersonDtlsApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper.js';
import MyInfoPersonDetails from '../components/MyInfoPersonDetails';
import marStatusArray from '../data/maritalstatus.json'
import titles from '../data/titles.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
import countriesDomicile from '../data/domicilecountries.json';
import mData from '../hybriddata/mainform.json';
import { Button } from "@progress/kendo-react-buttons";
 

const NSPersonDetails = (props) => {

    let timer; 
    const  authPer1 = '1', authPer2 = '2',authPer3 = '3', authPer4='4', authPer5='5';

    const dobRegex = new RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);  //XXXX-XX-XX

    const history = useHistory();

    const [holders, setHolders]  = useState([]);
    const [response, setResponse]  = useState();

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving,setIsSaving] = useState(false);

    //Show or Hide Details
    const [showMyInfoPersonDtls1, setShowMyInfoPersonDtls1] = useState(false);
    const [showMyInfoPersonDtls2, setShowMyInfoPersonDtls2] = useState(false);
    const [showMyInfoPersonDtls3, setShowMyInfoPersonDtls3] = useState(false);
    const [showMyInfoPersonDtls4, setShowMyInfoPersonDtls4] = useState(false);
    const [showMyInfoPersonDtls5, setShowMyInfoPersonDtls5] = useState(false);

    //Header Section Expend, default true
    const [isExpendAuth1,setIsExpendAuth1] = useState(true);
    const [isExpendAuth2,setIsExpendAuth2] = useState(true);
    const [isExpendAuth3,setIsExpendAuth3] = useState(true);
    const [isExpendAuth4,setIsExpendAuth4] = useState(true);
    const [isExpendAuth5,setIsExpendAuth5] = useState(true);

    const [applicantDetails1, setApplicantDetails1] = useState(null);
    const [applicantDetails2, setApplicantDetails2] = useState(null);
    const [applicantDetails3, setApplicantDetails3] = useState(null);
    const [applicantDetails4, setApplicantDetails4] = useState(null);
    const [applicantDetails5, setApplicantDetails5] = useState(null);

    const [loginAPCPFHistory, setLoginAPCPFHistory] = useState(null);
    const [loginAPYrAssestment, setLoginAPYrAssestment] = useState(null);
 
    const [authPersonList,setAuthPersonList] = useState([]);

    const [initFormData, setInitFormData] = useState({
     
        titleCbo1:"",
        marStatusCbo1:"",
        countOfDomicileCbo1:"",
        mno1:"",
        em1:"",
        mhLoanInstallmentCbo1:"",
    
        authPerCbo:"",
        titleCbo2:"",
        marStatusCbo2:"",
        countOfDomicileCbo2:"",
        mno2:"",
        em2:"",
        mhLoanInstallmentCbo2:"",
 
        titleCbo3:"",
        marStatusCbo3:"",
        countOfDomicileCbo3:"",
        mno3:"",
        em3:"",
        mhLoanInstallmentCbo3:"",
   
      
        titleCbo4:"",
        marStatusCbo4:"",
        countOfDomicileCbo4:"",
        mno4:"",
        em4:"",
        mhLoanInstallmentCbo4:"",
      

        titleCbo5:"",
        marStatusCbo5:"",
        countOfDomicileCbo5:"",
        mno5:"",
        em5:"",
        mhLoanInstallmentCbo5:""
   
    })

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        window.scrollTo(0,0);
        getStateIdFromQueryString();
        getData();

        return () => {
            clearTimeout(timer);
            setIsLoading(false);
        };
    }, []);

    const getStateIdFromQueryString = () => {
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        if(stateId) {
            storage.setStateId(stateId);
        }
    }

    const handleSubmit = (dataItem) => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            if(!validateApplicantDtls()) {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
                    showErrMsg(config.error.MyInfo.MissingData);
                }
                else {
                    showErrMsg(config.error.MyInfo.MissingDataSubAP);
                }
                return;
            }
            
            if(!validateApplicantDtlsDOB()) {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') { //first user
                    showErrMsg(config.error.MyInfo.InvalidDOB);
                }
                else {
                    showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                }
                return;
            }
        
            //save the form here 
            // console.log('formatJsonParams(data): ',formatJsonParams(data))
            savePersonDetails(formatJsonParams(data));
        }
    }

    const handleOnToggleClick = (id) => {
     
        if(id === authPer1) {
            setShowMyInfoPersonDtls1(!showMyInfoPersonDtls1);
        }
        else if(id === authPer2) {
            setShowMyInfoPersonDtls2(!showMyInfoPersonDtls2)
        }
        else if(id === authPer3) {
            setShowMyInfoPersonDtls3(!showMyInfoPersonDtls3)
        }
        else if(id === authPer4) {
            setShowMyInfoPersonDtls4(!showMyInfoPersonDtls4)
        }
        else if(id === authPer5) {
            setShowMyInfoPersonDtls5(!showMyInfoPersonDtls5)
        }
    }

    const savePersonDetails = (params) => {
        
        
        if(!validateForm(params.ApplicantDtls)) {
            return;
        }

        setIsSaving(true);
        service.put(params).then(res => {    
            setIsSaving(false);
            if(res.data.isSucess) {
                goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
 
    }
    
    const formatJsonParams = (data) => {
 
        let appDtlsArray = [];
      
        if(getLoginUserOrder(data) === authPer1) {
            if(response.Request_Form.FinancingProduct === config.bizFinancing.BTL 
                || storage.getIsGreenAP() === 'Y'
            ) {
                if(applicantDetails1 !== null)  appDtlsArray.push(formatApplicantObj1(data));
                if(applicantDetails2 !== null)  appDtlsArray.push(formatApplicantObj2(data));
                if(applicantDetails3 !== null)  appDtlsArray.push(formatApplicantObj3(data));
                if(applicantDetails4 !== null)  appDtlsArray.push(formatApplicantObj4(data));
                if(applicantDetails5 !== null)  appDtlsArray.push(formatApplicantObj5(data));
            }
            else { //hybrid or api
                if(applicantDetails1 !== null)  appDtlsArray.push(formatApplicantObj1(data));
                if(applicantDetails2 !== null)  appDtlsArray.push(formatApplicantObj2(data));
            }
        }
        else {
            if(getLoginUserOrder(data) === authPer2) {
                if(applicantDetails2 !== null)  appDtlsArray.push(formatApplicantObj2(data));
            }
            else if(getLoginUserOrder(data) === authPer3) {
                if(applicantDetails3 !== null)  appDtlsArray.push(formatApplicantObj3(data));
            }
            else if(getLoginUserOrder(data) === authPer4) {
                if(applicantDetails4 !== null)  appDtlsArray.push(formatApplicantObj4(data));
            }
            else if(getLoginUserOrder(data) === authPer5) {
                if(applicantDetails5 !== null)  appDtlsArray.push(formatApplicantObj5(data));
            }
        }

        let params = {
            StateId:storage.getStateId(),
            ReferenceNo: storage.getRefNo(),
            ApplicantDtls:appDtlsArray
        }

        return params;
    }
    
    const formatApplicantObj1 = (data) => {
  
        let ApplicantDtls1={};
        if(applicantDetails1.hasMyInfo) {
            ApplicantDtls1 = {
                OrderNumber: authPer1,
                IDNumber: applicantDetails1.myInfo.IDNumber,  
                Person_Name: applicantDetails1.myInfo.Person_Name,   
                TitleCode: data.titleCbo1 === null || data.titleCbo1 === ''? '':data.titleCbo1.value,
                MaritalStatusCode:data.marStatusCbo1 === null || data.marStatusCbo1 === ''? '':data.marStatusCbo1.value,
                MarStatusDesp: data.marStatusCbo1 === null || data.marStatusCbo1 === ''? '':data.marStatusCbo1.label,
                CountryOfResidenceCode:data.countOfDomicileCbo1 === null || data.countOfDomicileCbo1===''? '':data.countOfDomicileCbo1.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo1 === null || data.countOfDomicileCbo1===''? '': data.countOfDomicileCbo1.label,
                Position_Code:applicantDetails1.myInfo.Position_Code,
                Position_Desc:applicantDetails1.myInfo.Position_Desc,
                MobileNumber: data.mno1,
                Email_Address: data.em1,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo1 === null || data.mhLoanInstallmentCbo1 === ''? '':data.mhLoanInstallmentCbo1.value
            }
        }
        else {
            ApplicantDtls1 = {
                OrderNumber: authPer1,
                IDNumber: applicantDetails1.myInfo.IDNumber,  
                Person_Name: applicantDetails1.myInfo.Person_Name,   
                MobileNumber: data.mno1,
                Email_Address: data.em1
            }
        }
 
        return ApplicantDtls1;
    }

    const formatApplicantObj2 = (data) => {

        const selectedAuthPerson = data.authPerCbo;
        let idNum='',name='';
        if(storage.getIsFProdBTL() === 'f' && storage.getIsGreenAP() === 'N' && !applicantDetails2.hasMyInfo) {
            idNum = selectedAuthPerson.IDNumber;
            name = selectedAuthPerson.Person_Name;
        }
        else {
            idNum = applicantDetails2.myInfo.IDNumber;
            name = applicantDetails2.myInfo.Person_Name;
        }

        let ApplicantDtls2={};
        if(applicantDetails2.hasMyInfo) {
            ApplicantDtls2 = {
                OrderNumber: authPer2,
                IDNumber: applicantDetails2.myInfo.IDNumber,  
                Person_Name: applicantDetails2.myInfo.Person_Name,   
                TitleCode: data.titleCbo2 === null || data.titleCbo2 === ''? '':data.titleCbo2.value,
                MaritalStatusCode:data.marStatusCbo2 === null || data.marStatusCbo2 === ''? '':data.marStatusCbo2.value,
                MarStatusDesp: data.marStatusCbo2 === null || data.marStatusCbo2 === ''? '':data.marStatusCbo2.label,
                CountryOfResidenceCode:data.countOfDomicileCbo2 === null || data.countOfDomicileCbo2===''? '':data.countOfDomicileCbo2.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo2 === null || data.countOfDomicileCbo2===''? '': data.countOfDomicileCbo2.label,
                Position_Code:applicantDetails2.myInfo.Position_Code,
                Position_Desc:applicantDetails2.myInfo.Position_Desc,
                MobileNumber: data.mno2,
                Email_Address: data.em2,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo2 === null || data.mhLoanInstallmentCbo2 === ''? '':data.mhLoanInstallmentCbo2.value
            }
        }
        else {
            ApplicantDtls2 = {
                OrderNumber: authPer2,
                IDNumber: idNum,  
                Person_Name: name,   
                MobileNumber: data.mno2,
                Email_Address: data.em2
            }
        }

        return ApplicantDtls2;
    }

    const formatApplicantObj3 = (data) => {
 
        let ApplicantDtls3={};
        if(applicantDetails3.hasMyInfo) {
            ApplicantDtls3 = {
                OrderNumber: authPer3,
                IDNumber: applicantDetails3.myInfo.IDNumber,  
                Person_Name: applicantDetails3.myInfo.Person_Name,   
                TitleCode: data.titleCbo3 === null || data.titleCbo3 === ''? '':data.titleCbo3.value,
                MaritalStatusCode:data.marStatusCbo3 === null || data.marStatusCbo3 === ''? '':data.marStatusCbo3.value,
                MarStatusDesp: data.marStatusCbo3 === null || data.marStatusCbo3 === ''? '':data.marStatusCbo3.label,
                CountryOfResidenceCode:data.countOfDomicileCbo3 === null || data.countOfDomicileCbo3 ===''? '':data.countOfDomicileCbo3.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo3 === null || data.countOfDomicileCbo3 ===''? '': data.countOfDomicileCbo3.label,
                Position_Code:applicantDetails3.myInfo.Position_Code,
                Position_Desc:applicantDetails3.myInfo.Position_Desc,
                MobileNumber: data.mno3,
                Email_Address: data.em3,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo3 === null || data.mhLoanInstallmentCbo3 === ''? '':data.mhLoanInstallmentCbo3.value
            }
        }
        else {
            ApplicantDtls3 = {
                OrderNumber: authPer3,
                IDNumber: applicantDetails3.myInfo.IDNumber,  
                Person_Name: applicantDetails3.myInfo.Person_Name,   
                MobileNumber: data.mno3,
                Email_Address: data.em3
            }
        }

        return ApplicantDtls3;
    }

    const formatApplicantObj4 = (data) => {
       
        let ApplicantDtls4={};
        if(applicantDetails4.hasMyInfo) {
            ApplicantDtls4 = {
                OrderNumber: authPer4,
                IDNumber: applicantDetails4.myInfo.IDNumber,  
                Person_Name: applicantDetails4.myInfo.Person_Name,   
                TitleCode: data.titleCbo4 === null || data.titleCbo4 === ''? '':data.titleCbo4.value,
                MaritalStatusCode:data.marStatusCbo4 === null || data.marStatusCbo4 === ''? '':data.marStatusCbo4.value,
                MarStatusDesp: data.marStatusCbo4 === null || data.marStatusCbo4 === ''? '':data.marStatusCbo4.label,
                CountryOfResidenceCode:data.countOfDomicileCbo4 === null || data.countOfDomicileCbo4 ===''? '':data.countOfDomicileCbo4.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo4 === null || data.countOfDomicileCbo4 ===''? '': data.countOfDomicileCbo4.label,
                Position_Code:applicantDetails4.myInfo.Position_Code,
                Position_Desc:applicantDetails4.myInfo.Position_Desc,
                MobileNumber: data.mno4,
                Email_Address: data.em4,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo4 === null || data.mhLoanInstallmentCbo4 === ''? '':data.mhLoanInstallmentCbo4.value
            }
        }
        else {
            ApplicantDtls4 = {
                OrderNumber: authPer4,
                IDNumber: applicantDetails4.myInfo.IDNumber,  
                Person_Name: applicantDetails4.myInfo.Person_Name,   
                MobileNumber: data.mno4,
                Email_Address: data.em4
            }
        }

        return ApplicantDtls4;
    }

    const formatApplicantObj5 = (data) => {
      
        let ApplicantDtls5={};
        if(applicantDetails5.hasMyInfo) {
            ApplicantDtls5 = {
                OrderNumber: authPer5,
                IDNumber: applicantDetails5.myInfo.IDNumber,  
                Person_Name: applicantDetails5.myInfo.Person_Name,   
                TitleCode: data.titleCbo5 === null || data.titleCbo5 === ''? '':data.titleCbo5.value,
                MaritalStatusCode:data.marStatusCbo5 === null || data.marStatusCbo5 === ''? '':data.marStatusCbo5.value,
                MarStatusDesp: data.marStatusCbo5 === null || data.marStatusCbo5 === ''? '':data.marStatusCbo5.label,
                CountryOfResidenceCode:data.countOfDomicileCbo5 === null || data.countOfDomicileCbo5 ===''? '':data.countOfDomicileCbo5.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo5 === null || data.countOfDomicileCbo5 ===''? '': data.countOfDomicileCbo5.label,
                Position_Code:applicantDetails5.myInfo.Position_Code,
                Position_Desc:applicantDetails5.myInfo.Position_Desc,
                MobileNumber: data.mno5,
                Email_Address: data.em5,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo5 === null || data.mhLoanInstallmentCbo5 === ''? '':data.mhLoanInstallmentCbo5.value
            }
        }
        else {
            ApplicantDtls5 = {
                OrderNumber: authPer5,
                IDNumber: applicantDetails5.myInfo.IDNumber,  
                Person_Name: applicantDetails5.myInfo.Person_Name,  
                MobileNumber: data.mno5,
                Email_Address: data.em5
            }
        }

        return ApplicantDtls5;
    }

    const getLoginUserOrder = () => {

        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return authPer1;  // first user, default return 1
        }
        else {// not first login person, get current login user seq from ApplicantDtls array
            return getNonFirstUserSeq();
        }
    }

    const getNonFirstUserSeq = () => {
        if(!Array.isArray(response.ApplicantDtls)){ //check obj
            if(response.ApplicantDtls.IDNumber.trim() ===  response.ApplicantsDtlsMyInfo.IDNumber.trim()){
                return response.ApplicantDtls.OrderNumber;
            }
        }
        else { //array
            for(let i in response.ApplicantDtls) {
                if(response.ApplicantDtls[i].IDNumber.trim() ===  response.ApplicantsDtlsMyInfo.IDNumber.trim()){
                   
                    return response.ApplicantDtls[i].OrderNumber;
                }
            }
        }
    }

    const setAPExpendSection = (resData) => {
        try{
            let seq = authPer1;
            if(resData.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
                seq = authPer1;// first user, default return 1
            }
            else {// not first login person, get current login user seq from ApplicantDtls array
                if(resData.ApplicantDtls === null) { //SubAP, resData.ApplicantDtls should not be null. Redirect to Err Screen.
                    showErrMsg('Error: Invalid data.')
                    setIsLoading(false);
                    return;
                }

                if(!Array.isArray(resData.ApplicantDtls)){ //check obj
                    if(resData.ApplicantDtls.IDNumber ===  resData.ApplicantsDtlsMyInfo.IDNumber){
                        seq= resData.ApplicantDtls.OrderNumber;
                    }
                }
                else { //array
                    for(let i in resData.ApplicantDtls){
                        if(resData.ApplicantDtls[i].IDNumber === resData.ApplicantsDtlsMyInfo.IDNumber){
                            seq= resData.ApplicantDtls[i].OrderNumber;
                        }
                    }
                }
            }
     
            if(seq === authPer1) {
                setIsExpendAuth1(true);
                setIsExpendAuth2(true);
                setIsExpendAuth3(true);
                setIsExpendAuth4(true);
                setIsExpendAuth5(true);
            }
            else if(seq === authPer2) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(true);
                setIsExpendAuth3(false);
                setIsExpendAuth4(false);
                setIsExpendAuth5(false);
            }
            else if(seq === authPer3) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(true);
                setIsExpendAuth4(false);
                setIsExpendAuth5(false);
            }
            else if(seq === authPer4) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(false);
                setIsExpendAuth4(true);
                setIsExpendAuth5(false);
            }
            else if(seq === authPer5) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(false);
                setIsExpendAuth4(false);
                setIsExpendAuth5(true);
            }
        }catch(ex) {
            console.log('@setAPExpendSection ex',ex);
            setIsLoading(false);
        }
    }

    const validateApplicantDtls = () => {
        
        if(getLoginUserOrder() === authPer1 && applicantDetails1.hasMyInfo) {
            return validateMyInfoMandatoryFields(applicantDetails1,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && applicantDetails2.hasMyInfo) {
         
            return validateMyInfoMandatoryFields(applicantDetails2,'Authorised Person 2: ');
        }
        else if(getLoginUserOrder() === authPer3 && applicantDetails3.hasMyInfo) {
     
            return validateMyInfoMandatoryFields(applicantDetails3,'Authorised Person 3: ');
        }
        else if(getLoginUserOrder() === authPer4 && applicantDetails4.hasMyInfo) {
     
            return validateMyInfoMandatoryFields(applicantDetails4,'Authorised Person 4: ');
        }
        else if(getLoginUserOrder() === authPer5 && applicantDetails5.hasMyInfo) {
     
            return validateMyInfoMandatoryFields(applicantDetails5,'Authorised Person 5: ');
        }
        else {
            return true;
        }
    }
 
    const validateMyInfoMandatoryFields = (appDtls,title) => {
      
        let isValid = true;
        
        if(appDtls.myInfo.IDNumber === null || appDtls.myInfo.IDNumber === "" || appDtls.myInfo.IDNumber === undefined) {
            // console.log('invalid IDNum')
            isValid = false;
        }
        else if(appDtls.myInfo.DATE_OF_BIRTH === null || appDtls.myInfo.DATE_OF_BIRTH === "" || appDtls.myInfo.DATE_OF_BIRTH === undefined) {
            // console.log('invalid DOB')
            isValid = false;
        }
        else if(appDtls.myInfo.Gender === null || appDtls.myInfo.Gender === "" || appDtls.myInfo.Gender === undefined) {
            // console.log('invalid Gender')
            isValid = false;
        }
        else if(appDtls.myInfo.RACE_DESC === null || appDtls.myInfo.RACE_DESC === "" || appDtls.myInfo.RACE_DESC === undefined) {
            // console.log('invalid Race')
            isValid = false;
        }
        else if(appDtls.myInfo.NATIONALITY === null || appDtls.myInfo.NATIONALITY === "" || appDtls.myInfo.NATIONALITY === undefined) {
            // console.log('invalid Nationality')
            isValid = false;
        }
        else if(appDtls.myInfo.COUNTRY_OF_BIRTH === null || appDtls.myInfo.COUNTRY_OF_BIRTH === "" || appDtls.myInfo.COUNTRY_OF_BIRTH === undefined) {
            // console.log('invalid CnOfBirth')
            isValid = false;
        }
        else if(appDtls.myInfo.RESI_STS === null || appDtls.myInfo.RESI_STS === "" || appDtls.myInfo.RESI_STS === undefined) {
            // console.log('invalid ResStatus')
            isValid = false;
        }
        else if(appDtls.myInfo.Position_Code === null || appDtls.myInfo.Position_Code === "" || appDtls.myInfo.Position_Code === undefined) {
            // console.log('invalid Designation')
            isValid = false;  
        }
        else if(appDtls.myInfo.Position_Desc === null || appDtls.myInfo.Position_Desc === "" || appDtls.myInfo.Position_Desc === undefined) {
            // console.log('invalid Designation')
            isValid = false;  
        }
        // TODO: 17 Jul 2022, temporary disable. Need to put back when data file in place.
        else if(appDtls.myInfo.REG_ADD_TYPE !== config.addTypeForeign){
            if(appDtls.myInfo.REG_ADD_POSTAL_CODE === null || appDtls.myInfo.REG_ADD_POSTAL_CODE === "" || appDtls.myInfo.REG_ADD_POSTAL_CODE === undefined) {
                // console.log('invalid ResPostalCode')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_BLOCK_NO === null || appDtls.myInfo.REG_ADD_BLOCK_NO === "" || appDtls.myInfo.REG_ADD_BLOCK_NO === undefined) {
                // console.log('invalid ResBlkNo')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_STREET_NAME === null || appDtls.myInfo.REG_ADD_STREET_NAME === "" || appDtls.myInfo.REG_ADD_STREET_NAME === undefined) {
                // console.log('invalid ResStreet')
                isValid = false;
            }
        }
        else if(appDtls.myInfo.REG_ADD_TYPE === config.addTypeForeign) {
            if(appDtls.myInfo.REG_ADD_LINE1 === null || appDtls.myInfo.REG_ADD_LINE1 === "" || appDtls.myInfo.REG_ADD_LINE1 === undefined) {
                // console.log('invalid REG_ADD_LINE1')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_LINE2 === null || appDtls.myInfo.REG_ADD_LINE2 === "" || appDtls.myInfo.REG_ADD_LINE2 === undefined) {
                // console.log('invalid REG_ADD_LINE2')
                isValid = false;
            }
        }
       
        return isValid;
    }

    const validateApplicantDtlsDOB = () => {
        if(getLoginUserOrder() === authPer1 && applicantDetails1.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails1,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && applicantDetails2.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails2,'Authorised Person 2: ');
        }
        else if(getLoginUserOrder() === authPer3 && applicantDetails3.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails3,'Authorised Person 3: ');
        }
        else if(getLoginUserOrder() === authPer4 && applicantDetails4.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails4,'Authorised Person 4: ');
        }
        else if(getLoginUserOrder() === authPer5 && applicantDetails5.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails5,'Authorised Person 5: ');
        }
        else {
            return true;
        }
    }
    
    const validateMyInfoDOBFormat = (appDtls,title) => {
        let isValid = true;
        if(appDtls.myInfo.DATE_OF_BIRTH !== null || appDtls.myInfo.DATE_OF_BIRTH !== "" || appDtls.myInfo.DATE_OF_BIRTH !== undefined){
            if(dobRegex.test(appDtls.myInfo.DATE_OF_BIRTH) === false) {
                // console.log('invalid DOB format')
                isValid = false;
            }
        }
        return isValid;
    }
  
 

    const validateForm = (authDtlsArray) => {
 
        let isValid = true;
        const errMsgDesp = 'Please do not leave field blank.\nPlease fill in the text field.'
        for(let i in authDtlsArray) {
            if(authDtlsArray[i].OrderNumber === authPer1) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails1.hasMyInfo)){
                    setIsExpendAuth1(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
            if(authDtlsArray[i].OrderNumber === authPer2) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails2.hasMyInfo)){
                    setIsExpendAuth2(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
            if(authDtlsArray[i].OrderNumber === authPer3) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails3.hasMyInfo)){
                    setIsExpendAuth3(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
            if(authDtlsArray[i].OrderNumber === authPer4) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails4.hasMyInfo)){
                    setIsExpendAuth4(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
            if(authDtlsArray[i].OrderNumber === authPer5) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails5.hasMyInfo)){
                    setIsExpendAuth5(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
        }
  
        return isValid;
    }
    
    const isValidFormInputFields = (formData, hasMyInfo) => {
 
        let isValid = true;
        if(hasMyInfo) {
            if(formData.TitleCode === '') {
                isValid = false;
            }
            else if(formData.MaritalStatusCode === '') {
                isValid = false;
            }
            else if(formData.MarStatusDesp === '') {
                isValid = false;
            }
            else if(formData.CountryOfResidenceCode === '') {
                isValid = false;
            }
            else if(formData.CountryOfResidenceDesc === '') {
                isValid = false;
            }
            else if(formData.MobileNumber === '') {
                isValid = false;
            }
            else if(formData.Email_Address === '') {
                isValid = false;
            }
        }
        else {
            if(formData.MobileNumber === '') {
                isValid = false;
            }
            else if(formData.Email_Address === '') {
                isValid = false;
            }
        }

        if(!isValid) {
            showErrMsg(personDtlsData.error.EmptyField);
        }
   
        return isValid;
    }
    
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                if(res.data.model.fields === null) {
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
          
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.   
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
                
                if(checkIsLoginAPInHoldersArray(res.data.model.fields.request) === false) { //to prevent blank page if api return login AP NRIC not included in HoldersDetails List
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
                
                setAuthPersonList(getAuthPersonList(res.data.model.fields.request));
                checkIsLoginAPGreen(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err: ',err);
            setIsLoading(false);
            goToErrorPage(config.ErrType.EmptyAPDtls);
            return;
        })
    }

    const bindFormData = (resData) => {
      
        const data = resData.ApplicantDtls;  //to check for first time or not
        const myInfoData = resData.ApplicantsDtlsMyInfo;  // Login user 
       
        try{
            if(myInfoData && myInfoData !== null) { // check correct api response
                isFProductBTL(resData);
                isFProdProperty(resData);
                setResponse(resData);
                setAPExpendSection(resData);
                storage.setIsFirstTime(myInfoData.isFirstUser === 'true'? true:false);
                createCPFHistory(myInfoData);
                createAPYrofAssestment(myInfoData);
               
                if(data && data !== null) {  //not first time
                    if(data.length !== 0) { //not first time
                        bindAppDtlsFormData(resData)
                    }
                }
                else { // first time
                    bindFirstTime(resData);
                }
            }
            else {
                goToErrorPage(config.ErrType.EmptyAPDtls);
                setIsLoading(false);
            }
        }
        catch(ex) {
            console.log('bindFormData ',ex);
        }
    }

    const checkIsLoginAPGreen = (data) => {
        
        if(data.Request_Form.FinancingProduct === config.bizFinancing.BTL) {
            storage.setIsGreenAP('');
        }
        else {//Hybrid || AIP
            if(data.ApplicantsDtlsMyInfo.isAuthorisedPerson) {
                storage.setIsGreenAP(data.ApplicantsDtlsMyInfo.isAuthorisedPerson);
            }
            else {
                storage.setIsGreenAP('Y');
            }
        }
    }

    const checkIsLoginAPInHoldersArray = (data) => {
        let isValid = false;
        let holdersArray = getHoldersDtls(data);
        let loginAPIDNo = data.ApplicantsDtlsMyInfo.IDNumber;
        let result = null;
        if(loginAPIDNo !== null){
            try {
                result = holdersArray.find( ({ IDNumber }) => IDNumber === loginAPIDNo);
           
                if(result === null || result === undefined) {
                    isValid = false;
                }
                else {
                    isValid = true;
                }
            }
            catch(e) {

            }
        }

        // console.log('checkIsLoginAPInHoldersArray: ', isValid);
        return isValid;
    }
  
    const bindFirstTime = (resData) => {
        // console.log('bindFirstTime');
        const myInfoData = resData.ApplicantsDtlsMyInfo;
        
        let allHolders = getHoldersDtls(resData);
       
        setHolders(allHolders);
        let nonLoginHolders = []; 
        
        //setExpendSection(myInfoData.isFirstUser,authPer1)

        if(isSingleOwnerFlow(resData)) {
            for(let i in allHolders) {
                if(myInfoData.IDNumber.trim() === allHolders[i].IDNumber.trim()) {
                    let authPer1 = {
                        myInfo:myInfoData,
                        allowEdit:true,
                        contactDtlEdit:true,
                        hasMyInfo:true,
                        showCPFAndNOA:true
                     }
                    setApplicantDetails1(authPer1); 
                }
            }

            setApplicantDetails2(null);
            setApplicantDetails3(null);
            setApplicantDetails4(null);
            setApplicantDetails5(null);
            setIsLoading(false);
            return;
        }
    
        for(let i in allHolders) {
            if(myInfoData.IDNumber.trim() === allHolders[i].IDNumber.trim()) {
                let authPer1 = {
                    myInfo:myInfoData,
                    allowEdit:true,
                    contactDtlEdit:true,
                    hasMyInfo:true,
                    showCPFAndNOA:true
                 }
                setApplicantDetails1(authPer1); 
            }
            else { //Remove Login Person in Holders 
                nonLoginHolders.push(allHolders[i]);
            }
        }
        
        //Holders array without Login Person
       if(nonLoginHolders.length === 1) {
            setApplicantDetails2({
                myInfo:nonLoginHolders[0],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            });
            setApplicantDetails3(null);
            setApplicantDetails4(null);
            setApplicantDetails5(null);
        }
        else if(nonLoginHolders.length === 2) {
            setApplicantDetails2({
                myInfo:nonLoginHolders[0],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            });
            setApplicantDetails3({
                myInfo:nonLoginHolders[1],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })
    
            setApplicantDetails4(null);
            setApplicantDetails5(null);
        }
        else if(nonLoginHolders.length === 3) {
            setApplicantDetails2({
                myInfo:nonLoginHolders[0],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            });
            setApplicantDetails3({
                myInfo:nonLoginHolders[1],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })
            setApplicantDetails4({
                myInfo:nonLoginHolders[2],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })
        
            setApplicantDetails5(null);
        }
        else if(nonLoginHolders.length === 4) {
      
            setApplicantDetails2({
                myInfo:nonLoginHolders[0],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            });
            setApplicantDetails3({
                myInfo:nonLoginHolders[1],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })
            setApplicantDetails4({
                myInfo:nonLoginHolders[2],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })

            setApplicantDetails5({
                myInfo:nonLoginHolders[3],
                allowEdit:true,
                contactDtlEdit:true,
                hasMyInfo:false,
                showCPFAndNOA:false
            })
        }
        setIsLoading(false);
    }

    const bindAppDtlsFormData = (data) => {
    
    
        let appDtls1=null, appDtls2=null, appDtls3=null, appDtls4=null, appDtls5=null;
 
        if(!Array.isArray(data.ApplicantDtls)) {
            appDtls1 = data.ApplicantDtls;
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].OrderNumber === authPer1){
              
                    appDtls1= data.ApplicantDtls[i];
                }
                if(data.ApplicantDtls[i].OrderNumber === authPer2) {
                    appDtls2 = data.ApplicantDtls[i];
                }
                if(data.ApplicantDtls[i].OrderNumber === authPer3) {
                    appDtls3 = data.ApplicantDtls[i];
                }
                if(data.ApplicantDtls[i].OrderNumber === authPer4) {
                    appDtls4 = data.ApplicantDtls[i];
                }
                if(data.ApplicantDtls[i].OrderNumber === authPer5) {
                    appDtls5 = data.ApplicantDtls[i];
               }
            }
        }
  
        if(appDtls1 !== null){
            setApplicantDetails1({
                myInfo:getAuthDtlsData(appDtls1,data),
                allowEdit:checkAllowEdit(appDtls1,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP1(appDtls1,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls1,data.ApplicantsDtlsMyInfo)
            })
        }

   
        if(appDtls2 !== null){ 
            setApplicantDetails2({
                myInfo:getAuthDtlsData(appDtls2,data),
                allowEdit:checkAllowEdit(appDtls2,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP2(appDtls2,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls2,data.ApplicantsDtlsMyInfo)
            })
        }

        if(appDtls3 !== null){ 
            setApplicantDetails3({
                myInfo:getAuthDtlsData(appDtls3,data),
                allowEdit:checkAllowEdit(appDtls3,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP3(appDtls3,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls3,data.ApplicantsDtlsMyInfo)
            })
        }

        if(appDtls4 !== null){ 
            setApplicantDetails4({
                myInfo:getAuthDtlsData(appDtls4,data),
                allowEdit:checkAllowEdit(appDtls4,data.ApplicantsDtlsMyInfo),  
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP4(appDtls4,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls4,data.ApplicantsDtlsMyInfo)
            })
        }

        if(appDtls5 !== null){ 
            setApplicantDetails5({
                myInfo:getAuthDtlsData(appDtls5,data),
                allowEdit:checkAllowEdit(appDtls5,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP5(appDtls5,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls5,data.ApplicantsDtlsMyInfo)
            })
        }

        let authPersonCboValue = null;
        
        if(storage.getIsFProdBTL() !== 't' && storage.getIsGreenAP() ==='N') {
            authPersonCboValue = helper.getHolderObjInArray(appDtls2.IDNumber,getAuthPersonList(data))
        }
 
        setInitFormData({
            titleCbo1:appDtls1 !== null && appDtls1.TitleCode? helper.getObjInArray(appDtls1.TitleCode,titles):'',
            marStatusCbo1:appDtls1 !== null && appDtls1.MaritalStatusCode? helper.getObjInArray(appDtls1.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo1:appDtls1 !== null && appDtls1.CountryOfResidenceCode? helper.getObjInArray(appDtls1.CountryOfResidenceCode,countriesDomicile):'',
            mno1:appDtls1 !== null && appDtls1.MobileNumber? appDtls1.MobileNumber:'',
            em1:appDtls1 !== null && appDtls1.Email_Address? appDtls1.Email_Address:'',
            mhLoanInstallmentCbo1: appDtls1 !== null && appDtls1.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls1.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
            
            authPerCbo:authPersonCboValue,
            titleCbo2:appDtls2 !== null && appDtls2.TitleCode? helper.getObjInArray(appDtls2.TitleCode,titles):'',
            marStatusCbo2:appDtls2 !== null && appDtls2.MaritalStatusCode? helper.getObjInArray(appDtls2.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo2:appDtls2 !== null && appDtls2.CountryOfResidenceCode? helper.getObjInArray(appDtls2.CountryOfResidenceCode,countriesDomicile):'',
            mno2:appDtls2 !== null && appDtls2.MobileNumber? appDtls2.MobileNumber:'',
            em2:appDtls2 !== null && appDtls2.Email_Address? appDtls2.Email_Address:'',
            mhLoanInstallmentCbo2: appDtls2 !== null && appDtls2.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls2.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
     
            titleCbo3:appDtls3 !== null && appDtls3.TitleCode? helper.getObjInArray(appDtls3.TitleCode,titles):'',
            marStatusCbo3:appDtls3 !== null && appDtls3.MaritalStatusCode? helper.getObjInArray(appDtls3.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo3:appDtls3 !== null && appDtls3.CountryOfResidenceCode? helper.getObjInArray(appDtls3.CountryOfResidenceCode,countriesDomicile):'',
            mno3:appDtls3 !== null && appDtls3.MobileNumber? appDtls3.MobileNumber:'',
            em3:appDtls3 !== null && appDtls3.Email_Address? appDtls3.Email_Address:'',
            mhLoanInstallmentCbo3: appDtls3 !== null && appDtls3.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls3.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
          
            titleCbo4: appDtls4 !== null && appDtls4.TitleCode? helper.getObjInArray(appDtls4.TitleCode,titles):'',
            marStatusCbo4:appDtls4 !== null && appDtls4.MaritalStatusCode? helper.getObjInArray(appDtls4.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo4:appDtls4 !== null && appDtls4.CountryOfResidenceCode? helper.getObjInArray(appDtls4.CountryOfResidenceCode,countriesDomicile):'',
            mno4:appDtls4 !== null && appDtls4.MobileNumber? appDtls4.MobileNumber:'',
            em4:appDtls4 !== null && appDtls4.Email_Address? appDtls4.Email_Address:'',
            mhLoanInstallmentCbo4: appDtls4 !== null && appDtls4.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls4.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
    
            titleCbo5:appDtls5 !== null && appDtls5.TitleCode? helper.getObjInArray(appDtls5.TitleCode,titles):'',
            marStatusCbo5:appDtls5 !== null && appDtls5.MaritalStatusCode? helper.getObjInArray(appDtls5.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo5:appDtls5 !== null && appDtls5.CountryOfResidenceCode? helper.getObjInArray(appDtls5.CountryOfResidenceCode,countriesDomicile):'',
            mno5:appDtls5 !== null && appDtls5.MobileNumber? appDtls5.MobileNumber:'',
            em5:appDtls5 !== null && appDtls5.Email_Address? appDtls5.Email_Address:'',
            mhLoanInstallmentCbo5: appDtls5 !== null && appDtls5.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls5.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
        })

        setIsLoading(false);
    }

    const goToErrorPage = (errType) => {
        setIsLoading(false);
        props.history.push(config.route.InvalidEntity,{errType:errType});
    }

    const getAuthDtlsData = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){ // get the login's person
            return resData.ApplicantsDtlsMyInfo;  // return login user info
        }
        else {
            return authPerson;  //return from AuthDtls Array's object
        }
    }

    const showAPCPFAndNOA = (authPerson,loginPerson) => {
        if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {  //login user
            return true;
        }
        else {
            return false;
        }
    }

 

    const checkAllowEdit = (authPerson,loginPerson) => {
 
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {  //login user
            return true;
        }
        else {
            return false;
        }
    }

    const checkContactDtlsEdit = (loginPerson) => {
        if(loginPerson.isFirstUser === 'true') {  //first user
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP1 = (authPerson,resData) => {
     
        if(authPerson.IDNumber === resData.ApplicantsDtlsMyInfo.IDNumber){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant1 === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP2 = (authPerson,resData) => {
      
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
 
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant2  === 'true') {
      
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP3 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant3  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP4 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant4  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP5 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant5  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const setExpendSection = (isFirstUser,loginUserSeq) => {
        if(isFirstUser || loginUserSeq === authPer1){
            setIsExpendAuth1(true);
            setIsExpendAuth2(false);
            setIsExpendAuth3(false);
            setIsExpendAuth4(false);
            setIsExpendAuth5(false);
        }
        else {
            if(loginUserSeq === authPer2) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(true);
                setIsExpendAuth3(false);
                setIsExpendAuth4(false);
                setIsExpendAuth5(false);
            }
            else if(loginUserSeq === authPer3) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(true);
                setIsExpendAuth4(false);
                setIsExpendAuth5(false);
            }
            else if(loginUserSeq === authPer4) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(false);
                setIsExpendAuth4(true);
                setIsExpendAuth5(false);
            }
            else if(loginUserSeq === authPer5) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(false);
                setIsExpendAuth3(false);
                setIsExpendAuth4(false);
                setIsExpendAuth5(true);
            }
        }
    }

    const isSingleOwnerFlow = (data) => {
        let result = false;
        if(data.Request_Form.FinancingProduct !== config.bizFinancing.BTL) {
            if(data.ApplicantsDtlsMyInfo.isAuthorisedPerson === 'Y') { //Green AP
                result = true;
            }
            else {
                result = false;
            }
        }
        else {//BTL
            result = false;
        }

        // console.log('isSingleOwnerFlow',result);
        return result;
    }

    const getHoldersDtls = (data) => {
        let temp = [];
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNumber !== null && data.Holdersdetails.Person_Name !== null) {
                temp.push(data.Holdersdetails);
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNumber !== null && data.Holdersdetails[i].Person_Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
        }
        return temp;
    }

    const getAuthPersonList = (data) => {
        let temp = [];
        if(!Array.isArray(data.Holdersdetails)) {
            temp.push(data.Holdersdetails);
            return;
        }
       
        for(let i in data.Holdersdetails) {
            if(data.Holdersdetails[i].IDNumber !== null && data.Holdersdetails[i].Person_Name !== null &&
                data.ApplicantsDtlsMyInfo.IDNumber !== data.Holdersdetails[i].IDNumber
            ){
                temp.push(data.Holdersdetails[i]);
            }
        }

        return temp;
    }

    const createCPFHistory = (data) => {
        try{
            let temp = [], min=[], max = [];
            if(data.cpfContributionHistory && data.cpfContributionHistory !== null) {
                if(!Array.isArray(data.cpfContributionHistory)) {
                    temp.push(data.cpfContributionHistory);
                }
                else {
                    temp = data.cpfContributionHistory;
                }
        
                for (let i in temp) {
                    max.push(temp[i]);
                    if(i < 2) min.push(temp[i]);
                }
                
                setLoginAPCPFHistory({
                    minData:min,
                    maxData:max
                });
            }
            else {
                setLoginAPCPFHistory({
                    minData:min,
                    maxData:max
                });
            }
        }catch(ex) {
            setIsLoading(false);
        }
    }

    const createAPYrofAssestment = (data) => {
      
        if(data.yearOfAssessment && data.yearOfAssessment !== null && data.yearOfAssessment.income !==null) {
            let firstYrData = null;
            let secYrData = null;

            if(!Array.isArray(data.yearOfAssessment.income)) { // object
              firstYrData = data.yearOfAssessment.income;
              secYrData = null;
            }
            else { // array
               for(let i in data.yearOfAssessment.income) {
                 if(data.yearOfAssessment.income[i].RowNumber === "1") {
                    firstYrData = data.yearOfAssessment.income[i];
                 }
                 else if(data.yearOfAssessment.income[i].RowNumber === "2") {
                    secYrData = data.yearOfAssessment.income[i];
                 }
               }
            }
            
            setLoginAPYrAssestment({
                firstYear: {
                    employment: firstYrData === null? null: firstYrData.employment,
                    taxCategory: firstYrData === null? null:firstYrData.taxCategory,
                    year:firstYrData === null? null:firstYrData.year,
                    taxClearance: firstYrData === null? null:firstYrData.taxClearance,
                    assessableIncome: firstYrData === null? null:firstYrData.assessableIncome,
                    trade: firstYrData === null? null:firstYrData.trade,
                    rent: firstYrData === null? null:firstYrData.rent,
                    interest: firstYrData === null? null:firstYrData.interest
                  },
                  secondYear: {
                    employment: secYrData === null? null: secYrData.employment,
                    taxCategory: secYrData === null? null: secYrData.taxCategory,
                    year:secYrData === null? null: secYrData.year,
                    taxClearance: secYrData === null? null: secYrData.taxClearance,
                    assessableIncome: secYrData === null? null: secYrData.assessableIncome,
                    trade: secYrData === null? null: secYrData.trade,
                    rent: secYrData === null? null: secYrData.rent,
                    interest: secYrData === null? null: secYrData.interest
                  }
            });
        }
        else {
            setLoginAPYrAssestment({
                firstYear: {
                    employment: null,
                    taxCategory: null,
                    year:null,
                    taxClearance: null,
                    assessableIncome: null,
                    trade: null,
                    rent: null,
                    interest: null
                  },
                  secondYear: {
                    employment: null,
                    taxCategory: null,
                    year:null,
                    taxClearance: null,
                    assessableIncome: null,
                    trade: null,
                    rent: null,
                    interest: null
                  }
            });
        }
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const goNext = () => {
        
        storage.setIsAPSavedForm(true);
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            if(storage.getIsFirstTime()=== "true") {
                if(storage.getIsFProdBTL() === 't') { //existing
                    history.push(config.route.AccountDetails);//exsting
                }
                else {
         
                    if(storage.getIsFPTypeProperty() === 't') { 
                       
                        if(storage.getIsPureAIP() === 'true') {
                            history.push(config.route.PropertyDetailsAIP);
                        }
                        else {
                            history.push(config.route.PropertyDetails);
                        }
                
                    }
                    else {
                        history.push(config.route.DeclarationsDetails); // declarations
                    }
                }
            }
            else {
                history.push(config.route.DeclarationsDetails);
            }
        
        }
    }

    const isFirstUser = () => {
        if(response && response.ApplicantsDtlsMyInfo.isFirstUser==='true') {
            return true;
        }
        else {
            return false;
        }
    }

    const isFProductBTL = (res) => {
        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.FinancingProduct === mData.bizFinanceType.Online) { //existing BTL
                result = true;
            }
            else { //PBF or AIP
                result = false;
            }
        }
  
        storage.setIsFProdBTL(result?'t':'f');
    }

    const isFProdProperty = (res)=> {

        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.Property === 'Y') { //property selected, Hybrid Property
                result = true;
            }
            else if(resData.FinancingProduct === mData.bizFinanceType.AIP) { //AIP 
                result = true;
            }
        }
        storage.setIsFPTypeProperty(result?'t':'f');
    }
    
    if(isLoading) {
        return(
          <Loading />
        )
    }

    return (
        response ? 
        <div className="container-fluid"> 
            <SubHeader title={config.Branding.title}
                img={!isFirstUser()?subAPImg:(storage.getIsFProdBTL() === 't')?headerImg:storage.getIsFPTypeProperty() === 't'?pStepper:stepper} /><br/>
                <Form onSubmitClick={handleSubmit}
                    initialValues= {initFormData}
                    key={JSON.stringify(initFormData)}
                    render={(formRenderProps)=>(
                        <FormElement>
                           <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={personDtlsData.formContainerTitle.T1} name={personDtlsData.formContainerTitle.T1.name} />
                            {/* Auth Person 1 */}
                            {applicantDetails1 !== null &&
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer1} 
                                    name={(applicantDetails1.myInfo.Person_Name !== null)? applicantDetails1.myInfo.Person_Name:''}
                                    rightlblId={'lblPer1'} rightlblName={'Fill Up Form'}
                                    isExpend={isExpendAuth1}
                                    doneMyInfo ={applicantDetails1.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth1){
                                            setIsExpendAuth1(false);
                                        }
                                        else {
                                            setIsExpendAuth1(true);
                                        } 
                                    }} />
                                {isExpendAuth1 &&
                                    <div>
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                  <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer1} toggle={showMyInfoPersonDtls1} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails1.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                                    </FieldWrapper>
                                    {showMyInfoPersonDtls1 && 
                                    <MyInfoPersonDetails personDetails={applicantDetails1} order={authPer1} />
                                    }

                                    <AuthPerson 
                                        applicantDetails={applicantDetails1} showDetails={showMyInfoPersonDtls1} formRenderProps={formRenderProps}
                                        hasMyInfo={applicantDetails1.hasMyInfo} seq={authPer1} holders={authPersonList} 
                                        cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} 
                                        showAuthPerDDL={false}
                                        /> 
                                    </div>
                                }
                                </div>
                            }

                            {/* Auth Person 2 */}
                            {applicantDetails2 !== null &&
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer2} name={applicantDetails2.myInfo.Person_Name}
                                    rightlblId={'lblPer'+authPer2} rightlblName={applicantDetails2.hasMyInfo? 'Fill Up Form':'Fill Up Contact'}
                                    isExpend={isExpendAuth2}
                                    doneMyInfo ={applicantDetails2.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth2){
                                            setIsExpendAuth2(false);
                                        }
                                        else {
                                            setIsExpendAuth2(true);
                                        } 
                                    }} />
                                    {isExpendAuth2 &&
                                    <div>
                                    {applicantDetails2.hasMyInfo && 
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer2} toggle={showMyInfoPersonDtls2} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails2.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                               
                                    {showMyInfoPersonDtls2 && 
                                        <MyInfoPersonDetails personDetails={applicantDetails2} order={authPer1} />
                                    }
                                    </FieldWrapper>
                                    }

                                    <AuthPerson 
                                        applicantDetails={applicantDetails2} showDetails={showMyInfoPersonDtls2} formRenderProps={formRenderProps}
                                        hasMyInfo={applicantDetails2.hasMyInfo} seq={authPer2} holders={authPersonList}
                                        cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment}
                                        showAuthPerDDL={storage.getIsGreenAP() === 'N'?true:false} />

                                    </div>
                                    }
                                
                                </div>
                            }

                            {(response.Request_Form.FinancingProduct === config.bizFinancing.BTL)&&
                            <div>
                                {/* Auth Person 3 */}
                                {applicantDetails3 !== null &&
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer3} name={applicantDetails3.myInfo.Person_Name}
                                    rightlblId={'lblPer'+authPer3} rightlblName={applicantDetails3.hasMyInfo? 'Fill Up Form':'Fill Up Contact'}
                                    isExpend={isExpendAuth3}
                                    doneMyInfo ={applicantDetails3.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth3){
                                            setIsExpendAuth3(false);
                                        }
                                        else {
                                            setIsExpendAuth3(true);
                                        } 
                                    }} />
                                {isExpendAuth3 &&
                                    <div>
                                    {applicantDetails3.hasMyInfo && 
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer3} toggle={showMyInfoPersonDtls3} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails3.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                               
                                    {showMyInfoPersonDtls3 && 
                                        <MyInfoPersonDetails personDetails={applicantDetails3} order={authPer3} />
                                    }
                                    </FieldWrapper>
                                }
                                
                                <AuthPerson 
                                    applicantDetails={applicantDetails3} showDetails={showMyInfoPersonDtls3} formRenderProps={formRenderProps}
                                    hasMyInfo={applicantDetails3.hasMyInfo} seq={authPer3} holders={authPersonList} 
                                    cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} 
                                    showAuthPerDDL={false}
                                    />
                                    </div>
                                }
                                </div>
                                }

                                {/* Auth Person 4 */}
                                {applicantDetails4 !== null &&
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer4} name={applicantDetails4.myInfo.Person_Name}
                                    rightlblId={'lblPer'+authPer4} rightlblName={applicantDetails4.hasMyInfo? 'Fill Up Form':'Fill Up Contact'}
                                    isExpend={isExpendAuth4}
                                    doneMyInfo ={applicantDetails4.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth4){
                                            setIsExpendAuth4(false);
                                        }
                                        else {
                                            setIsExpendAuth4(true);
                                        } 
                                    }} />

                                {isExpendAuth4 &&
                                    <div>
                                    {applicantDetails4.hasMyInfo && 
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer4} toggle={showMyInfoPersonDtls4} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails4.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                               
                                    {showMyInfoPersonDtls4 && 
                                        <MyInfoPersonDetails personDetails={applicantDetails4} order={authPer4} />
                                    }
                                    </FieldWrapper>
                                }
                                
                                <AuthPerson 
                                    applicantDetails={applicantDetails4} showDetails={showMyInfoPersonDtls4} formRenderProps={formRenderProps}
                                    hasMyInfo={applicantDetails4.hasMyInfo} seq={authPer4} holders={authPersonList} 
                                    cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} 
                                    showAuthPerDDL={false} /> 
                                    </div>
                                }
                                </div>
                                }
                            
                                {/* Auth Person 5 */}
                                {applicantDetails5 !== null &&
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer5} name={applicantDetails5.myInfo.Person_Name}
                                    rightlblId={'lblPer'+authPer5} rightlblName={applicantDetails5.hasMyInfo? 'Fill Up Form':'Fill Up Contact'}
                                    isExpend={isExpendAuth5}
                                    doneMyInfo ={applicantDetails5.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth5){
                                            setIsExpendAuth5(false);
                                        }
                                        else {
                                            setIsExpendAuth5(true);
                                        } 
                                    }} />
                                {isExpendAuth5 && 
                                    <div>
                                    {applicantDetails5.hasMyInfo && 
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer5} toggle={showMyInfoPersonDtls5} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails5.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                               
                                    {showMyInfoPersonDtls5 && 
                                        <MyInfoPersonDetails personDetails={applicantDetails5} order={authPer5} />
                                    }
                                    </FieldWrapper>
                                }
                                
                                <AuthPerson 
                                    applicantDetails={applicantDetails5} showDetails={showMyInfoPersonDtls5} formRenderProps={formRenderProps}
                                    hasMyInfo={applicantDetails5.hasMyInfo} seq={authPer5} holders={authPersonList}
                                    cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} 
                                    showAuthPerDDL={false} />
                                    </div>
                                }
                                </div>
                                }
                            </div>
                            }
                            </fieldset>
                            <br/>
                            </FormContainer>
                            <FormContainer>
                                <div style={{paddingTop:'20px',paddingBottom: "20px"}}>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                                            <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right" 
                                                disabled={!formRenderProps.valid}>
                                                {config.btnName.Next}
                                            </Button>
                                            <Button type={"button"} style={{border:'1px solid #343a40'}}
                                                className="k-button btn btnMargin btn-back"
                                                disabled={response.ApplicantsDtlsMyInfo.isFirstUser === 'false'? true:false} 
                                                onClick={(e) => { 
                                                    e.preventDefault(); 
                                                    history.push(config.route.CompanyDetails+'?state='+storage.getStateId());}}>
                                                {config.btnName.Back}
                                            </Button>
                                        </div>
                                    </div> 
                                </div>
                            </FormContainer>
                            <FieldWrapper></FieldWrapper>
                        </FormElement>
                    )}>
                </Form>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
            {isSaving && <Loading />}
        </div>
        :
        <></>
    )
}

export default NSPersonDetails;